import Image from "next/image"

const AboutUsHero = () => {
    return (
        <div className="relative flex h-screen w-full items-center justify-center overflow-hidden">
            <Image
                src="https://passticketscdn.azureedge.net/frontend/Desktop-1-min_jmdtg2.png"
                alt="About Us Page Banner"
                width={1920}
                height={0}
                layout="responsive"
                className="h-screen bg-cover bg-center lg:h-full"
                quality="100"
                // fill
            />
            {/* <div className="hero-scroll-container absolute bottom-0 left-0 right-0 top-0 text-white">
                <div className="hero-scroll-text absolute mr-8">
                    <div className="flex flex-col pt-10">
                        <AnimatedText />

                        <span className="text-6xl font-bold text-black"></span>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default AboutUsHero
